import { createContext } from 'react';
import { INav, INavState } from '../_types/nav';



const nullNav: INav = { 
  open: true,
  openMenus: [],
  backLinks: []
};

const defaultNavState: INavState = {
    nav: nullNav,
    setNav: (): void => {},
  };

export const NavigationContext = createContext<INavState>(defaultNavState);